module.exports = {"title":"Make an order"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/in/setting/order/locale.json
// module id = 649
// module chunks = 0 1 2 3 4 5